/* unplugin-vue-components disabled */import script from "./Zone.vue?vue&type=script&setup=true&lang=ts"
export * from "./Zone.vue?vue&type=script&setup=true&lang=ts"

import "./Zone.vue?vue&type=style&index=0&id=7ef60656&scoped=true&lang=less"

import exportComponent from "/Users/crossle/Code/github.com/OneMornin/mornin.one/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ef60656"]])

export default __exports__